module.exports = require('./helpers/bundle-url').getBundleURL('6YPom') + "logo.7718c6df.svg";